export const getEmbeddedJson = (id: string) =>
  JSON.parse(document.getElementById(id)?.textContent ?? '');
